import { render, staticRenderFns } from "./LEDPCB.vue?vue&type=template&id=cde0b832&scoped=true&"
import script from "./LEDPCB.vue?vue&type=script&lang=js&"
export * from "./LEDPCB.vue?vue&type=script&lang=js&"
import style0 from "./LEDPCB.vue?vue&type=style&index=0&id=cde0b832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde0b832",
  null
  
)

export default component.exports